(() => {
  if (window.__proSizeChartDrawerLoaded) return;
  window.__proSizeChartDrawerLoaded = true;

  const getActiveDrawer = () =>
    document.querySelector('pro-size-chart-drawer.is-active');

  const unlockBodyWhenPossible = () => {
    const anotherDrawerIsOpen = document.querySelector(
      'cart-drawer.active, pro-size-chart-drawer.is-active'
    );

    if (!anotherDrawerIsOpen) {
      document.body.classList.remove('overflow-hidden');
    }
  };

  class ProSizeChartDrawer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.proSizeChartPortaled !== 'true') {
        const ownerSection = this.closest('.shopify-section, [id^="shopify-section-"]');
        const computedStyle = window.getComputedStyle(this);

        this.dataset.proSizeChartPortaled = 'true';
        this.dataset.proSizeChartOwnerId = ownerSection?.id || '';

        ['--color-background', '--color-foreground'].forEach((property) => {
          const value = computedStyle.getPropertyValue(property).trim();
          if (value) this.style.setProperty(property, value);
        });

        document.body.appendChild(this);
        return;
      }

      if (this.dataset.proSizeChartReady === 'true') return;
      this.dataset.proSizeChartReady = 'true';

      this.panel = this.querySelector('.pro-size-chart-drawer__panel');
      this.closeButton = this.querySelector('.pro-size-chart-drawer__close');

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-pro-size-chart-close]')) {
          this.close();
        }
      });
    }

    disconnectedCallback() {
      if (!this.classList.contains('is-active')) return;

      this.classList.remove('is-active');
      this.setAttribute('aria-hidden', 'true');
      unlockBodyWhenPossible();
    }

    open(trigger) {
      if (this.classList.contains('is-active')) return;

      getActiveDrawer()?.close();

      this.openedBy = trigger || null;
      this.openedBy?.setAttribute('aria-expanded', 'true');
      this.setAttribute('aria-hidden', 'false');
      this.classList.add('is-active');
      document.body.classList.add('overflow-hidden');

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (typeof window.trapFocus === 'function' && this.panel) {
            window.trapFocus(this.panel, this.closeButton || this.panel);
          } else {
            (this.closeButton || this.panel)?.focus({ preventScroll: true });
          }
        });
      });
    }

    close() {
      if (!this.classList.contains('is-active')) return;

      this.classList.remove('is-active');
      this.setAttribute('aria-hidden', 'true');
      this.openedBy?.setAttribute('aria-expanded', 'false');

      if (typeof window.removeTrapFocus === 'function') {
        window.removeTrapFocus(this.openedBy);
      } else {
        this.openedBy?.focus({ preventScroll: true });
      }

      this.openedBy = null;
      unlockBodyWhenPossible();
    }
  }

  if (!customElements.get('pro-size-chart-drawer')) {
    customElements.define('pro-size-chart-drawer', ProSizeChartDrawer);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-pro-size-chart-open]');
    if (!trigger) return;

    const drawerId = trigger.getAttribute('aria-controls');
    const drawer = drawerId ? document.getElementById(drawerId) : null;

    if (!(drawer instanceof ProSizeChartDrawer)) return;

    event.preventDefault();
    drawer.open(trigger);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    getActiveDrawer()?.close();
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const ownerId = event.target?.id;
    if (!ownerId) return;

    document.querySelectorAll('pro-size-chart-drawer[data-pro-size-chart-owner-id]').forEach((drawer) => {
      if (drawer.dataset.proSizeChartOwnerId !== ownerId) return;
      drawer.remove();
    });
  });
})();
